class SectionVideoTime implements ng.IComponentController {
    ltTitle: string;
    description: string;
    video: anm.LandingVideo;
    buttons: anm.LandingButtonData[];
    timeSteps: anm.LandingTimeStep[];
    background: anm.LandingBackground;
    currentVideoTime       = 0;
    isScrollButton: boolean;
    introduceVideoShow: boolean;
    private wistiaVideo: any;
    private lastWistiaTime = 0;
    private wistiaOptions  = {
        volume: 0
    };

    private wistiaCrosstimeListeners: {fun: () => any, time: number}[] = [];

    constructor(private $stateParams: ng.ui.IStateParamsService) {
        this.ltTitle            = this.$stateParams.t || this.ltTitle;
        this.description        = this.$stateParams.d || this.description;
        this.introduceVideoShow = this.$stateParams.iv;
    }

    $onDestroy() {
        this.unBindWistiaCrosstime();
    }

    handlerWistiaModalClose() {
        this.introduceVideoShow = false;
        this.currentVideoTime   = this.lastWistiaTime;
    }

    changeVideoTime(timeStep: anm.LandingTimeStep) {
        this.setActive(timeStep);
        this.currentVideoTime = timeStep.time;
    }

    setWistiaPlayer(video: any) {
        this.wistiaVideo = video;
        this.wistiaVideo.volume(this.wistiaOptions.volume);
        this.timeSteps.forEach(timeStep => this.bindWistiaCrosstime(timeStep));
    }

    private setActive(timeStep: anm.LandingTimeStep) {
        this.timeSteps.forEach(ts => ts.isActive = false);
        timeStep.isActive   = true;
        this.lastWistiaTime = timeStep.time;
    }

    private unBindWistiaCrosstime() {
        if (this.wistiaVideo) {
            this.wistiaCrosstimeListeners.forEach(o => this.wistiaVideo.unbind('crosstime', o.time, o.fun));
        }
    }

    private bindWistiaCrosstime(timeStep: anm.LandingTimeStep) {
        const bindFun = () => this.setActive(timeStep);
        this.wistiaCrosstimeListeners.push({
            fun: bindFun,
            time: timeStep.time
        });
        this.wistiaVideo && this.wistiaVideo.bind("crosstime", timeStep.time, bindFun);
    }
}

angular.module('animatronApp.sectionVideoTime', []).component('sectionVideoTime', {
    bindings: {
        ltTitle: '<',
        description: '<',
        buttons: '<',
        video: '<',
        timeSteps: '<',
        background: '<',
        isScrollButton: '<'
    },
    controller: SectionVideoTime,
    templateUrl: require('landing-template/components/sections/section-video-time.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionVideoTime.ts